let ParsleyEventsView = require('./ParsleyEventsView');
let parsleyEventsView = new ParsleyEventsView();

let onLoad = (callback) => {
    $('document').ready( () => {
        callback();
    });
};

let resetForm = () => {
    parsleyEventsView.formValidate();
};

let showFieldErrors = (messages, element, fieldId) => {
    parsleyEventsView.showFieldErrors(messages, element, fieldId);
};

let addTempCardButtonLoading = function() {
    $("#register-check-card-button").addClass("btn-loading");
    $("#register-check-card-button").prop("disabled", true);
};

let removeTempCardButtonLoading = function () {
    $("#register-check-card-button").removeClass("btn-loading");
    $("#register-check-card-button").prop("disabled", false);
};

module.exports = {
    onLoad: onLoad,
    showFieldErrors: showFieldErrors,
    resetForm: resetForm,
    addTempCardButtonLoading: addTempCardButtonLoading,
    removeTempCardButtonLoading: removeTempCardButtonLoading,
    webUrl: () => $("#temporary-card-details").attr("web-url"),
};
